/* eslint-disable no-console */
/* eslint-disable id-length */
import * as Sentry from '@sentry/browser'

export default class Logger {
  enabled = false
  owner = ''
  color = null

  environment = _ENVIRONMENT_

  constructor(owner, enabled = false, color = null) {
    this.owner = owner
    this.enabled = enabled
    this.color = color

    if (color === null) this.color = this.intToRGB(this.hashCode(owner))
  }

  enable() {
    this.enable = true
  }

  disable() {
    this.enable = false
  }

  hashCode(str) {
    let hash = 0
    for (let i = 0; i < str.length; i++) hash = str.charCodeAt(i) + ((hash << 5) - hash)

    return hash
  }

  intToRGB(i) {
    const c = (i & 0x00ffffff).toString(16).toUpperCase()
    return '00000'.substring(0, 6 - c.length) + c
  }

  stringify(...args) {
    const rtn = []

    args.forEach((item) => {
      rtn.push(item)
    })

    return rtn
  }

  logItem(type, ...args) {
    const itemsArr = this.stringify(...args)
    const isLive = this.environment === 'production'
    const enableLog = type === 'error' || type === 'debug' || window.mableDebugOn === true
    if (enableLog || !isLive) {
      const [error, message, extra = undefined] = args
      const sentryExtraData = { extra }

      if (type === 'error') {
        Sentry.withScope((scope) => {
          scope.setTag('error_source', error || this.owner)
          if (message instanceof Error) Sentry.captureException(message, sentryExtraData)
          else if (typeof message === 'object') {
            if (message && message.message)
              Sentry.captureException(new Error(message), sentryExtraData)
            else Sentry.captureException(new Error(JSON.stringify(message)), sentryExtraData)
          } else Sentry.captureException(new Error(message), sentryExtraData)
        })
      } else if (type === 'debug') {
        const debugMessage = args?.length > 1 ? args.join(' ') : args[0]
        Sentry.captureMessage(debugMessage, 'debug')
      }
      if (!isLive) {
        console[type](`%c${this.owner}`, `color: #${this.color};`, ...itemsArr)
        return
      }

      return console[type](this.owner, itemsArr)
    }
  }

  log = (...args) => this.enabled && this.logItem('log', ...args)
  dir = (...args) => this.enabled && this.logItem('dir', ...args)
  warn = (...args) => this.enabled && this.logItem('warn', ...args)
  info = (...args) => this.enabled && this.logItem('info', ...args)
  error = (...args) => this.enabled && this.logItem('error', ...args)
  table = (...args) => this.enabled && this.logItem('table', ...args)
}

const logsEndpoint = `${_API_BASE_URL_}/screening/room/logs`
const serverLoggerInstance = new Logger('ServerLogger', true)
let axiosInstancePromise = null

const getAxiosInstance = async () => {
  if (!axiosInstancePromise) {
    axiosInstancePromise = import('./AxiosInstance.js').then((module) => module.default)
  }
  return axiosInstancePromise
}

export const logServerEvent = async (pupilScreenerId, event, data) => {
  if (!pupilScreenerId) return

  try {
    const AxiosInstance = await getAxiosInstance()
    await AxiosInstance.post(logsEndpoint, {
      pupilScreenerId,
      timestamp: new Date().toISOString(),
      event,
      data
    })
  } catch (error) {
    serverLoggerInstance.error('Failed to log server event', error)
  }
}
